<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Funnel report</h3>
            </d-col>
        </d-row>
        <analysis-filters />
        <d-card
            v-if="!isLoading && transactions.length > 0"
            ref="transaction-rows"
            class="card-small transactions-group"
        >
            <funnel-report-row-item
                v-for="transaction in transactions"
                :key="transaction.id"
                :transaction="transaction"
                :currency="getCurrencies(transaction.domain)"
            />
            <d-card-footer class="p-0 mt-3">
                <pagination
                    v-if="!isLoading"
                    :options="paginationOptions"
                    :records="total"
                    v-model="currentPage"
                    :per-page="itemsPerPage"
                    @paginate="paginate(currentPage)"
                />
            </d-card-footer>
        </d-card>
        <d-alert
            v-else-if="!isLoading && transactions.length === 0"
            theme="warning"
            show
        >
            No records found. Please try to set different filters.
        </d-alert>
        <d-card v-if="isLoading" class="d-flex flex-column align-items-center p-4">
            <h5 class="mb-4">
                Loading transactions
            </h5>
            <div
                class="spinner-border text-primary"
                role="status"
            >
                <span class="sr-only">
                    Loading...
                </span>
            </div>
        </d-card>
    </d-container>
</template>

<script>
    import notification from '@/mixins/notification'
    import loader from '@/mixins/loader'
    import AnalysisFilters from '@/components/analysis/analysisFilters.vue'
    import { WebsiteService, AnalysisService } from '@/main'
    import FunnelReportRowItem from '@/components/analysis/funnelReportRowItem.vue'

    export default {
        mixins: [notification, loader],

        components: {
            AnalysisFilters,
            FunnelReportRowItem
        },

        data() {
            return {
                currentPage: 1,
                itemsPerPage: 50,
                total: 0,
                isLoading: true,
                websites: [],
                website: null,
                transactions: [],
                paginationOptions: {
                    chunk: 5,
                    texts: {
                        count: 'Showing {from} to {to} of {count} transactions|{count} transactions|One transaction'
                    }
                },
            }
        },
        computed: {
            getAnalysisStore() {
                return this.$store.getters['analysisStore/getState']
            },
        },
        methods: {
            paginate() {
                this.isLoading = true
                this.getTransactions()
            },
            getCurrencies(websiteDomain) {
                const found = this.websites.find((website) => {
                    return website.domain === websiteDomain
                })
                return found ? found.currency.code : 'EUR'
            },
            async getTransactions() {
                this.isLoading = true
                try {
                    const transactionsData = await AnalysisService.getFunnelReport(
                        this.currentPage, this.getAnalysisStore.fromDate, this.getAnalysisStore.toDate, this.getAnalysisStore.websiteId
                    );
                    this.transactions = await transactionsData.data
                    this.itemsPerPage = await transactionsData.per_page
                    this.total = await transactionsData.total
                    this.isLoading = false
                } catch(e) {
                    this.showNotification('warn', 'Oops.. We have a problem!', 'Please try again later')
                    console.error(e)
                }
            },

            async getWebsites() {
                try {
                    const websites = await WebsiteService.get()
                    this.websites = websites
                } catch(e) {
                    this.showNotification('warn', 'Oops! we have a problem', 'Oops! cant get domains')
                    console.error(e)
                }
            },
        },

        beforeDestroy() {
            this.$eventHub.$off('apply-analysis-filters')
        },

        mounted() {
            this.getWebsites()
            this.getTransactions()
            this.$eventHub.$on('apply-analysis-filters', this.getTransactions)
        },
    }
</script>
